import { connect } from 'react-redux';
import { Creators } from '../../../services/redux/map/actions';
import LeafletMap from './components';

const mapStateToProps = state => {
  const { lineId, geoJsonData, isloading } = state.map;
  return {
    lineId,
    isloading,
    geoJsonData,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    saveLineId: (lineId) => {
      dispatch(Creators.saveLineId(lineId));
    },
    fetchGeoJsonData: () => {
      dispatch(Creators.fetchGeojsonData());
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LeafletMap);

